import organizationStore from "./organization/store";
import hrmStore from "./hrm/store";
import payrollStore from "./payroll/store";
import attendanceStore from "./attendance/store";
import performanceStore from "./performance/store";
import recruitmentStore from "./recruitment/store";
import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    pageSizes: [5, 10, 20, 30, 40],
    showNeyaModal: false,
    constants: {
      barChartMaxWidth: 600,
      barChartMaxHeight: 500,
    },
    downloadFormats: [
      { label: "CSV", value: "csv" },
      //{label: "PDF", value: "pdf"}
    ],
    allApprovers: [],
    approversTotal: null,
    tableLoading: false,
    searchQuery: "",
    pageApprover: 1,
    perPageApprover: 5,
  },
  actions,
  mutations,
  modules: {
    organization: organizationStore,
    hrm: hrmStore,
    attendance: attendanceStore,
    payroll: payrollStore,
    performance: performanceStore,
    recruitment: recruitmentStore,
  },
};
